module.exports = __webpack_public_path__ + "prod/1.42.2/img/superiority3.e1541fbb.png";